import React, { useState, useEffect } from "react";
import { navLinks, profileData } from "../../data/mock";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNavClick = (href) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#06080D]/85 backdrop-blur-xl border-b border-[#1E293B]/40 shadow-lg shadow-black/20"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
          className="flex items-center gap-2 group cursor-pointer"
        >
          <div className="w-8 h-8 rounded-lg bg-[#06B6D4]/15 border border-[#06B6D4]/20 flex items-center justify-center text-[#06B6D4] font-bold text-xs font-['Fira_Code']">
            S
          </div>
          <span className="text-[#F1F5F9] font-['Figtree'] font-semibold text-lg tracking-tight">
            {profileData.name.split(" ")[0]}
            <span className="text-[#06B6D4]">.</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="px-4 py-2 text-sm text-[#64748B] hover:text-[#F1F5F9] transition-colors duration-200 rounded-lg hover:bg-[#0F1629]/80 font-['IBM_Plex_Sans']"
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* CTA + Mobile toggle */}
        <div className="flex items-center gap-3">
          <a
            href="#contact"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("#contact");
            }}
            className="hidden md:inline-flex items-center gap-2 px-5 py-2 rounded-lg bg-[#06B6D4]/10 text-[#06B6D4] text-sm font-medium hover:bg-[#06B6D4]/15 transition-colors duration-200 border border-[#06B6D4]/20"
          >
            Let's Talk
          </a>
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 text-[#64748B] hover:text-[#F1F5F9] transition-colors"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="md:hidden bg-[#06080D]/95 backdrop-blur-xl border-b border-[#1E293B]/40 px-6 py-4">
          {navLinks.map((link) => (
            <button
              key={link.href}
              onClick={() => handleNavClick(link.href)}
              className="block w-full text-left px-4 py-3 text-[#64748B] hover:text-[#F1F5F9] hover:bg-[#0F1629]/80 rounded-lg transition-colors text-sm"
            >
              {link.label}
            </button>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;
